export const APP_USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  BLOCKED: "blocked",
} as const;

export const isActiveAppUser = (status?: string | null) =>
  status?.toLowerCase() === APP_USER_STATUS.ACTIVE;

export const isBlockedAppUser = (status?: string | null) =>
  status === APP_USER_STATUS.BLOCKED;

export const getAppUserToggleStatus = (status?: string | null) =>
  isActiveAppUser(status)
    ? APP_USER_STATUS.INACTIVE
    : APP_USER_STATUS.ACTIVE;

export const APP_USER_STATUS_BADGE: Record<string, string> = {
  [APP_USER_STATUS.ACTIVE]: "light-success",
  [APP_USER_STATUS.INACTIVE]: "light-warning",
  [APP_USER_STATUS.BLOCKED]: "light-danger",
};

export const APP_USER_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: APP_USER_STATUS.ACTIVE, label: "Active" },
  { value: APP_USER_STATUS.INACTIVE, label: "Inactive" },
  { value: APP_USER_STATUS.BLOCKED, label: "Blocked" },
];

export const CLIENT_USERS_LIST_PATH = "/apps/user/client-users";
export const getClientUserViewPath = (id: string | number) =>
  `${CLIENT_USERS_LIST_PATH}/view/${id}`;

export const BUSINESS_USERS_LIST_PATH = "/apps/user/business-users";
export const getBusinessUserViewPath = (id: string | number) =>
  `${BUSINESS_USERS_LIST_PATH}/view/${id}`;
